module.exports = __webpack_public_path__ + "static/media/document-process.557b933e.gif";